import { useMount } from 'react-use';
import { getCookie, setCookie } from '~/utils/dom.utils';
import { v4 as uuid } from 'uuid';
import { IAuthorizedAnalyticsService } from '~/services/analytics/analytics.service';
import { IAnalyticsService } from '~/services/interfaces/IAnalyticsService';
import { getQueryParam } from '~/utils/url.utils';
import { EnvTypes, getEnvType, isDevelopment } from '~/utils/environment.utils';
import { MARKETING_STABLE_ID_COOKIE_NAME } from '~/components/Signup/constants/general';

export const HB_ANONYMOUS_ID_COOKIE_NAME = 'hb_anonymous_id';

const { pathname } = location;

const isPublicTemplate =
    pathname.includes('/template/view') ||
    pathname.includes('/template-preview');

const isSignupPage = pathname === '/signup';

let cookieDomain = isPublicTemplate ? '.hbportal.co' : '.honeybook.com';
if (isDevelopment()) {
    cookieDomain = 'localhost';
} else if (getEnvType() === EnvTypes.Staging) {
    cookieDomain = '.hbdev.io';
}

const queryParamStableId = getQueryParam(HB_ANONYMOUS_ID_COOKIE_NAME);

export const useInitHBAnonymousId = ({
    analyticsService
}: {
    analyticsService: IAuthorizedAnalyticsService | IAnalyticsService;
}) => {
    useMount(async () => {
        if (!isSignupPage && !isPublicTemplate) {
            return;
        }
        let hbAnonymousId = getCookie(HB_ANONYMOUS_ID_COOKIE_NAME);
        if (!hbAnonymousId) {
            hbAnonymousId =
                queryParamStableId ||
                getCookie(MARKETING_STABLE_ID_COOKIE_NAME) ||
                uuid();
            setCookie({
                cookieName: HB_ANONYMOUS_ID_COOKIE_NAME,
                cookieValue: hbAnonymousId,
                domain: cookieDomain
            });
        }
        analyticsService.setHBAnonymousId(hbAnonymousId);
        analyticsService.overrideSegmentAnonymousId(hbAnonymousId);
    });
};
